// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

const campaignOrWorkflowValidator = objectOf({
  id: string,
  name: string,
});

export const isOfferfitAppGroupIdUseCasesUseCaseIdResult = objectOf({
  id: string,
  client: string,
  pipeline: string,
  usecase: string,
  usecase_display_name: string,
  campaigns: arrayOf(campaignOrWorkflowValidator),
  workflows: arrayOf(campaignOrWorkflowValidator),
});
